import React, {
  createContext, FC, useContext, useReducer,
} from 'react';
import { InMemoryCacheData } from '@ynomia/client';
import { ActionFromPayloadMap } from '../config/types';
import ClientCacheReducer from '../reducers/clientCache';

export type ClientCacheStateType = {
  clientCache: InMemoryCacheData | null
};

const initialState: ClientCacheStateType = {
  clientCache: null,
};

export type ClientCacheActionPayloadMap = {
  SET_CLIENT_CACHE: ClientCacheStateType['clientCache'];
};

export type ClientCacheAction = ActionFromPayloadMap<ClientCacheActionPayloadMap>;

export const ClientCacheContext = createContext({
  state: initialState,
  dispatch: (() => { }) as React.Dispatch<ClientCacheAction>,
});

export const useClientCache = (): [ClientCacheStateType, React.Dispatch<ClientCacheAction>] => {
  const { state, dispatch } = useContext(ClientCacheContext);
  return [state, dispatch];
};

export const ClientCacheProvider:FC<React.PropsWithChildren<{}>> = ({ children }) => {
  const [state, dispatch] = useReducer(ClientCacheReducer, initialState);

  return (
    <ClientCacheContext.Provider
      // eslint-disable-next-line react/jsx-no-constructed-context-values
      value={{
        state,
        dispatch,
      }}
    >
      {children}
    </ClientCacheContext.Provider>
  );
};
